import { render, staticRenderFns } from "./CooperationDetailTable.vue?vue&type=template&id=ed9fb124&scoped=true"
import script from "./CooperationDetailTable.vue?vue&type=script&lang=js"
export * from "./CooperationDetailTable.vue?vue&type=script&lang=js"
import style0 from "./CooperationDetailTable.vue?vue&type=style&index=0&id=ed9fb124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9fb124",
  null
  
)

export default component.exports